module.exports = __webpack_public_path__ + "media/frontend/svg/info-3a28c093d14ba647444220b75230fec2.svg";